import { toast } from 'sonner';

/**
 * O aviso que as telas do portal público mostram em vez de gravar.
 *
 * Nenhuma das telas deste módulo (Páginas, Navegação, Configurações) grava hoje: não
 * há rota de portal público na API (`apps/api/src/modulos/` não tem esse módulo), e a
 * interface pode existir antes do backend para validação com a SMT/DTP (CLAUDE.md,
 * seção "Proibido", exceção de 2026-08-22). Por isso nenhum botão de salvar, criar ou
 * excluir chama API nenhuma: cada um só mostra este aviso.
 */
export function avisarAcaoIndisponivel(): void {
  toast('Ação ainda não disponível', {
    description: 'Estamos preparando esta funcionalidade. Em breve você poderá salvar por aqui.',
  });
}
